/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestTermTreatmentPlanDto } from '../../models/request-term-treatment-plan-dto';
import { TermTreatmentPlanResponseDto } from '../../models/term-treatment-plan-response-dto';

export interface DocumentAiV2ControllerGenerateTermTreatmentPlan$Params {
  centerId: string;
  type: 'user' | 'center';
      body: RequestTermTreatmentPlanDto
}

export function documentAiV2ControllerGenerateTermTreatmentPlan(http: HttpClient, rootUrl: string, params: DocumentAiV2ControllerGenerateTermTreatmentPlan$Params, context?: HttpContext): Observable<StrictHttpResponse<TermTreatmentPlanResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiV2ControllerGenerateTermTreatmentPlan.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.query('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TermTreatmentPlanResponseDto>;
    })
  );
}

documentAiV2ControllerGenerateTermTreatmentPlan.PATH = '/api/document-ai-v2/term-treatment-plan-ai';
